'use client';

import type { FC } from 'react';

import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'next-share';

import Image from 'next/image';

import facebookIcon from '/public/images/icons/social/facebook-icon.svg';
import linkedinIcon from '/public/images/icons/social/linkedin-icon.svg';
import twitterIcon from '/public/images/icons/social/twitter-icon.svg';

type PropTypes = {
  url: string;
};

const SocialShareButtons: FC<PropTypes> = ({ url }) => {
  return (
    <div className="social-links">
      <ul>
        <li>
          <FacebookShareButton url={url}>
            <Image alt="facebook" src={facebookIcon} width={20} height={20} quality="70" />
          </FacebookShareButton>
        </li>
        <li>
          <TwitterShareButton url={url}>
            <Image alt="twitter" src={twitterIcon} width={20} height={20} quality="70" />
          </TwitterShareButton>
        </li>
        <li>
          <LinkedinShareButton url={url}>
            <Image alt="linkedin" src={linkedinIcon} width={20} height={20} quality="70" />
          </LinkedinShareButton>
        </li>
      </ul>
    </div>
  );
};

export default SocialShareButtons;
